<template>
  <div class="announcement_container" v-show="announcementData && announcementData.length > 0">
    <div class="icon_wrapper">
      <i class="iconfont icon-icon_shouye_gonggao"></i>
      <span class="icon_text">{{ $t('app_home_notice') }}</span>
    </div>

    <swiper
      :modules="modules"
      :slides-per-view="1"
      loop
      :autoplay="{
        disableOnInteraction: false
      }"
      direction="vertical"
      class="content_warpper swiper-no-swiping"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="(item, index) in announcementData"
        :key="index"
        class="content_slide"
        @click="skipHandle(item)"
      >
        <p class="content_text">{{ item.remark }}</p>
      </swiper-slide>
    </swiper>

    <div class="more_icon">
      <i class="iconfont icon-icon_shouye_tiaozhuan"></i>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper as SwiperType, Autoplay } from 'swiper'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed, onDeactivated, onActivated, ref } from 'vue'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const swiperInstance = ref()
const setSwiper = (swiper: SwiperType) => {
  swiperInstance.value = swiper
}
onDeactivated(() => {
  swiperInstance.value.autoplay.pause()
})
onActivated(() => {
  swiperInstance.value.autoplay.start()
})

const router = useRouter()
interface TItem {
  appJumpStatus: number
  appJumpUrl: string
  appJumpCourseType: number
}
const skipHandle = (item: TItem) => {
  switch (item.appJumpStatus) { // 链接
    case 1:
      handleExternalUrl({ jumpUrl: item.appJumpUrl })
      break
    case 2:
      router.push({ // 课程
        name: 'courseDetail',
        query: {
          id: item.appJumpUrl,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: item.appJumpCourseType === 0 ? 'course' : 'courseWare'
        }
      })
      break
    case 3: // 资讯
      router.push('/broadcastDetail/' + item.appJumpUrl)
      break
    case 4: // 培训
      router.push('/trainingDetail?id=' + item.appJumpUrl)
      break
    case 5: // 考试
      router.push('/examInfo?examId=' + item.appJumpUrl)
      break
    case 6: // 调查
      router.push('/surveyInfo?investigationId=' + item.appJumpUrl)
      break
    default:
      break
  }
}

const announcementData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const modules = [Autoplay]

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.announcement_container {
  margin: 12px 16px;
  padding: 0 12px;
  background-color: @contentBackground;
  border-radius: 8px;
  display: flex;
  align-items: center;
  .icon_wrapper {
    min-width: 48px;
    height: 20px;
    padding: 0 5px;
    background-color: v-bind(themeColorWithAlpha);
    border-radius: 4px;
    .flex_center;
    .iconfont {
      margin-top: 2px;
      font-size: 12px;
      color: v-bind(themeColor);
    }
    .icon_text {
      font-size: 12px;
      color: v-bind(themeColor);
      transform: scale(0.833);
      transform-origin: center;
    }
  }
  .content_warpper {
    height: 44px;
    margin-left: 10px;
    flex: 1;
    color: @textNormal;

    .content_text {
      height: 44px;
      line-height: 44px;
      font-size: 13px;
      .text_etc;
    }
  }
  .more_icon {
    width: 20px;
    height: 20px;
    .flex_center;
    .iconfont {
      font-size: 12px;
      color: @textSecondary99;
    }
  }
}
</style>
